/**
 * Split an option's display into the bold city name and the muted region. A
 * `disambiguator` (coordinates) is appended when another visible option shares
 * the same label, so two real towns never read as one.
 */
export function formatPlaceOptionLabel(display: string, disambiguator?: string) {
  const cityName = display.split(",")[0].trim();
  const baseRegion = display.slice(cityName.length + 1).trim();
  const region = disambiguator
    ? [baseRegion, disambiguator].filter(Boolean).join(" · ")
    : baseRegion;
  const label = region ? `${cityName}, ${region}` : cityName;
  return { cityName, region, label };
}
